import React from 'react';
import { StackItem } from '@domain-group/fe-blueprint-ui/layout';
import * as styles from './average-star-rating-and-total.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AverageRatingText = _ref => {
  var value = _ref.value,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'l' : _ref$size;
  return ___EmotionJSX(StackItem, null, ___EmotionJSX("span", {
    css: styles.avgRating(size)
  }, value.toFixed(1)));
};
export { AverageRatingText };